import ApiService from './Api.service.js';

class UnityService extends ApiService {
  reorderLessons(userId, moduleId, lessons) {
    return this.resource.put(`user/${userId}/module/${moduleId}/lessons/reorder`, lessons);
  }
}

export default new UnityService('units');



// WEBPACK FOOTER //
// ./src/services/axios/units.service.js